import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  customerType,
  isValidNumber,
  unitCaseEnum,
} from '../../utils/settings';
import Form from 'antd/es/form';
import { GetAllCityOfState } from '../../screen/auth/action/util_actions';
import { useLocation, useNavigate } from 'react-router-dom';
import Screenback from '../../components/screenBack/screenBack';
import FmcgProdCard from '../Components/FmcgProdCard';
import {
  AddDistributorSellInvoice,
  sellProductWithProductCompanyIdAction,
} from '../../screen/distributor/action/util_action';
import moment from 'moment';
import {
  Box,
  Container,
  Grid,
  Stack,
  TextField,
  ToggleButtonGroup,
  Button,
  Card,
  CardHeader,
  CardContent,
  ToggleButton,
  IconButton,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { Add, DeleteOutline, Edit } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CartViewController = () => {
  const [distArr, setDistArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { state } = useLocation();

  const [selectedCompany, setSelectedCompany] = useState(
    state?.selectedCompany || {},
  );
  const toggleButtonlist = [
    { value: 0, label: state?.selectedCompany?.allocable_quantity?.unit },
    {
      value: 1,
      label: state?.selectedCompany?.allocable_quantity?.base_unit,
    },
  ];
  const [sellQty, setSellQty] = useState();
  const [alignment, setAlignment] = useState(0);
  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceDate, setInvoiceDate] = useState(moment().format('YYYY-MM-DD'));

  const {
    loginUser,
    deliveryAddressDetails,
    cartItemList,
    retailers,
    unitCaseWise,
    selectedStp,
    seller_id,
  } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
      cart: state.orderReducer.cart,
      deliveryAddressDetails: state.orderReducer.deliveryAddressDetails,
      company_id: state.orderReducer.company_id,
      distributor: state.orderReducer.distributor,
      cartItemList: state.fmcgReducer.cartItemList,
      unitCaseWise: state.fmcgReducer.unitCaseWise,
      retailers: state.orderReducer.retailers,
      selectedStp: state.bcmOrderReducer.selectedStp,
      seller_id: state.bcmOrderReducer.seller_id,
    };
  });

  const productListComponent = () => {
    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: '5px',
        }}
      >
        <CardHeader
          title={
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              color='#637381'
            >
              {selectedCompany.is_inventory_homogeneous
                ? 'Enter Quantity To Sell'
                : 'Products'}
            </Typography>
          }
          action={
            !selectedCompany?.is_inventory_homogeneous && (
              <Tooltip title='Add More Products to Sell'>
                <IconButton
                  onClick={() => {
                    navigate(`/distributor/inventory`, {
                      state: {
                        companyId: seller_id,
                        isFromSelltoBuyer: true,
                      },
                    });
                  }}
                  sx={{ color: '#F49D3F' }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )
          }
          sx={{ backgroundColor: '#f4f6f8', px: 2, py: 1 }}
        />
        <CardContent>
          <Box sx={{ padding: { xs: 0, sm: 2 } }}>
            {selectedCompany.is_inventory_homogeneous ? (
              <Box>
                <Grid
                  container
                  spacing={2}
                  alignItems='center'
                >
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    md={9}
                    container
                    alignItems='center'
                    spacing={2}
                  >
                    <Grid item>
                      <Typography variant='h6'>Available Quantity</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant='h6'>
                        {alignment
                          ? `${selectedCompany?.allocable_quantity?.quantity_in_bags} ${selectedCompany.allocable_quantity.base_unit}`
                          : `${selectedCompany?.allocable_quantity?.quantity_in_metric_ton} ${selectedCompany.allocable_quantity.unit}`}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={3}
                    container
                    justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
                  >
                    <ToggleButtonGroup
                      value={alignment}
                      exclusive
                      onChange={handleAlignment}
                      aria-label='text alignment'
                    >
                      {toggleButtonlist.map((toggleButton) => (
                        <ToggleButton
                          key={toggleButton.value}
                          value={toggleButton.value}
                          aria-label={toggleButton.value}
                        >
                          {toggleButton.label}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                  </Grid>
                </Grid>
                <TextField
                  margin='normal'
                  fullWidth
                  id='sellquantity'
                  label='Sell Quantity'
                  name='sellquantity'
                  value={sellQty}
                  onChange={(e) => setSellQty(e.target.value)}
                />
              </Box>
            ) : (
              <Box>
                {cartItemList.map((prod, index) => (
                  <FmcgProdCard
                    key={index}
                    prod={prod}
                    index={index}
                    itemInCart={prod}
                    checkout={true}
                    noShadow={true}
                  />
                ))}
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
    );
  };

  useEffect(() => {
    const addressDetails = {
      deliveryAddress: loginUser?.company_details?.address,
      deliveryPincode: loginUser?.company_details?.pincode,
      requestedDistrictId: {
        label: loginUser?.company_details?.district_id.district_name,
        value: loginUser?.company_details?.district_id?.id,
      },
    };
    dispatch({
      type: 'SAVE_ADDRESS',
      address: addressDetails,
    });
  }, [loginUser]);

  const adressAndCartView = () => {
    return (
      <div>
        <div>{deliveryAddressComponent()}</div>
        <div>{cartTotalComponent()}</div>
      </div>
    );
  };
  const getDistrictOptions = () => {
    return distArr.length > 0
      ? distArr.map((district) => ({
          label: district.district_name,
          value: district.id,
        }))
      : [];
  };

  const getAllCityOfState = async (stateId) => {
    if (stateId >= 0) {
      await GetAllCityOfState(stateId)
        .then((districts) => {
          setDistArr(districts);
          let { error, data } = districts;
          if (!error && data) {
            setDistArr(data);
          }
        })
        .catch();
    }
  };

  useEffect(() => {
    if (loginUser?.company_details?.district_id?.state.id) {
      getAllCityOfState(loginUser?.company_details?.district_id?.state.id);
    }
  }, [loginUser]);

  const cartTotalComponent = () => {
    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: '5px',
        }}
      >
        <CardHeader
          title={
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              color='#637381'
            >
              Checkout
            </Typography>
          }
          sx={{ backgroundColor: '#f4f6f8', px: 2, py: 1 }}
        />
        <CardContent>
          <Stack
            direction='column'
            spacing={2}
            alignItems='center'
          >
            {/* Invoice Number */}
            <TextField
              fullWidth
              id='invoice_number'
              label='Invoice Number'
              name='invoice_number'
              autoComplete='invoice_number'
              autoFocus
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />

            {/* Invoice Date */}
            <TextField
              fullWidth
              label='Invoice Date'
              id='invoice_date'
              name='invoice_date'
              type='date'
              value={invoiceDate}
              onChange={(e) => setInvoiceDate(e.target.value)}
              inputProps={{
                max: moment().format('YYYY-MM-DD'),
                min: moment().subtract(1, 'months').format('YYYY-MM-DD'),
              }}
            />

            {/* Checkout Button */}
            <Button
              variant='contained'
              color='warning'
              fullWidth
              sx={{
                height: 50,
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              disabled={loading}
              onClick={
                selectedCompany.is_inventory_homogeneous
                  ? onSellByQuantity
                  : onCheckOut
              }
            >
              Proceed to Checkout
            </Button>
          </Stack>
        </CardContent>
      </Card>
    );
  };

  const onCheckOut = async () => {
    if (Object.keys(selectedStp).length === 0)
      return toast.error('Please add Delivery Address');
    if (cartItemList.length === 0)
      return toast.error('Please add Products to cart');

    const newPayload = {
      products: cartItemList.map((prod) => {
        const sellQty = prod.sellToBuyerQty.qty;
        return {
          product_id: prod.product_info.product_id,
          quantity: {
            quantity_in_bags:
              (unitCaseWise === unitCaseEnum['UNIT'] && sellQty) || null,
            quantity_in_metric_ton:
              (unitCaseWise === unitCaseEnum['CASE'] && sellQty) || null,
            multiplier: prod.allocable_quantity.multiplier,
            unit: prod.allocable_quantity.unit,
            base_unit: prod.allocable_quantity.base_unit,
          },
          deliver_to: selectedStp.company_id,
          price_per_unit: 0,
          gst_amount: 0,
          total_amount: 0,
          product_gst_percentage: 0,
        };
      }),
      invoice_no: invoiceNumber,
      invoice_files_base64: [],
      date_of_invoice: moment(invoiceDate).format('YYYY-MM-DD'),
    };

    setLoading(true);

    const { error, message } = await AddDistributorSellInvoice(newPayload);

    setLoading(false);

    if (!error) {
      return navigate('/fmcg/order-completed', { replace: true });
    } else {
      toast.error(message);
    }
  };

  const onSellByQuantity = async () => {
    if (Object.keys(selectedStp).length === 0)
      return toast.error('Please add Delivery Address');

    if (!sellQty) return toast.error('Please add sell quantity');

    if (!isValidNumber(sellQty))
      return toast.error('Please add valid sell quantity');

    const payload = {
      product_company_id: selectedCompany.company_id,
      quantity: {
        quantity_in_bags: alignment ? Number(sellQty) : null,
        quantity_in_metric_ton: alignment ? null : Number(sellQty),
        multiplier: 1000,
        unit: selectedCompany.allocable_quantity.unit,
        base_unit: selectedCompany.allocable_quantity.base_unit,
      },
      price_per_unit: 0,
      discount: 0,
      tax_amount: 0,
      total_amount: 0,
      invoice_no: invoiceNumber,
      buy_or_sell_to: selectedStp.company_id,
      invoice_files_base64: [],
      date_of_invoice: moment(invoiceDate).format('YYYY-MM-DD'),
    };

    const { error, message } = await sellProductWithProductCompanyIdAction(
      payload,
    );

    if (!error) {
      return navigate('/fmcg/order-completed', { replace: true });
    } else {
      toast.error(message);
    }
  };

  function clearRetailer() {
    dispatch({
      type: 'SET_SELECTED_STP',
      data: {},
    });
    dispatch({ type: 'CLEAR_RETAILERS' });
  }

  const deliveryAddressComponent = () => {
    return (
      <Card sx={{ mb: 2, borderRadius: '5px' }}>
        <CardHeader
          title={
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              color='#637381'
            >
              Deliver To
            </Typography>
          }
          sx={{ backgroundColor: '#f4f6f8', px: 2, py: 1 }}
          action={
            Object.keys(selectedStp).length > 0 ? (
              <Stack
                direction='row'
                spacing={1}
              >
                <Tooltip title='Remove Retailer'>
                  <IconButton
                    onClick={clearRetailer}
                    sx={{ color: '#F49D3F' }}
                  >
                    <DeleteOutline />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Edit Retailer'>
                  <IconButton
                    onClick={() => {
                      navigate('/order-booking/ship-to-party-details', {
                        state: {
                          buyerDetails: selectedStp,
                          isFromEditOrderDetails: false,
                          isSellToBuyer: true,
                          isEditingSelectedStp: true,
                        },
                      });
                    }}
                    sx={{ color: '#F49D3F' }}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Stack>
            ) : (
              <Tooltip title='Add Retailer'>
                <IconButton
                  onClick={() => {
                    dispatch({
                      type: 'ADD_USER_DATA',
                      data: {
                        buyerId: customerType['DEALER'],
                        fromOrderDetails: false,
                        editUserData: {},
                      },
                    });

                    navigate('/order-booking/select-ship-to-party', {
                      state: { fromFmcgCart: true },
                    });
                  }}
                  sx={{ color: '#F49D3F' }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )
          }
        />
        <CardContent>
          <Grid
            container
            spacing={1}
          >
            {[
              { label: 'Firm Name:', key: 'company_name' },
              { label: 'Phone Number:', key: 'company_phone_no' },
              { label: 'Address:', key: 'company_address', isAddress: true },
            ].map((item) => (
              <Grid
                container
                key={item.key}
                alignItems='center'
                sx={{ mb: 1 }}
              >
                <Grid
                  item
                  xs={5}
                >
                  <Typography
                    variant='body2'
                    fontWeight='bold'
                  >
                    {item.label}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={7}
                >
                  <Typography variant='body2'>
                    {item.isAddress
                      ? `${selectedStp.delivery_Address_line1 || ''}, ${
                          selectedStp.delivery_Address_line2 || ''
                        }`
                      : selectedStp[item.key]}
                  </Typography>
                </Grid>
              </Grid>
            ))}

            {retailers.length > 0 && (
              <>
                {[
                  { label: 'Firm Name:', key: 'firm_name' },
                  { label: 'Delivery Address:', key: 'address' },
                  { label: 'Phone Number:', key: 'retailor_phone' },
                  { label: 'GSTIN:', key: 'company_gstin' },
                  { label: 'PAN:', key: 'pancard_no' },
                ].map((item) => (
                  <Grid
                    container
                    key={item.key}
                    alignItems='center'
                    sx={{ mb: 1 }}
                  >
                    <Grid
                      item
                      xs={5}
                    >
                      <Typography
                        variant='body2'
                        fontWeight='bold'
                      >
                        {item.label}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={7}
                    >
                      <Typography variant='body2'>
                        {retailers[0][item.key]}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
    );
  };
  return (
    <Container
      maxWidth='true'
      sx={{ pl: '1rem', py: '1rem' }}
    >
      <Stack
        direction={'row'}
        spacing={2}
        alignItems={'center'}
        sx={{ mb: '1rem' }}
      >
        <IconButton
          onClick={() => {
            navigate(`/distributor/inventory`, {
              state: {
                companyId: seller_id,
                isFromSelltoBuyer: true,
              },
            });
          }}
          sx={{ color: 'black' }}
        >
          <ArrowBackIcon fontSize={'medium'} />
        </IconButton>
        <Typography variant='h5'>Cart </Typography>
      </Stack>
      <Grid
        container
        spacing={3}
        justifyContent='center'
        sx={{ width: '100%' }}
      >
        <Grid
          item
          xs={12}
          lg={8}
        >
          {productListComponent()}
        </Grid>
        <Grid
          item
          xs={12}
          lg={4}
        >
          {adressAndCartView()}
        </Grid>
      </Grid>
    </Container>
  );
};

export default CartViewController;
